import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-category-coupon-slider-2',
  templateUrl: './category-coupon-slider-2.component.html',
  styleUrls: ['./category-coupon-slider-2.component.css']
})

export class CategoryCouponSlider2Component implements OnInit {
  @Input() coupon: any;
  @Input() category: any;
  @Input() typeCode: number;

  @Output() couponSettingsChanged = new EventEmitter<any>();

  changeCouponSettings() {
    this.couponSettingsChanged.emit(this.typeCode);
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/category-coupons-slider/category-coupon-slider-2/category-coupon-slider-2.component.ts